<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import {computed} from "vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const isAffiliateProgram = computed(() => {
    const programType = portalContentAndDesignStore.program?.program_type?.type || 
                       portalContentAndDesignStore.program?.programType?.type;
    return programType === 'affiliate';
});

const leadsEnabled = computed(() => {
    return portalContentAndDesignStore.landingPageSettings?.leads_enabled ?? false;
});
</script>

<template>
    <div class="space-y-4">
        <text-field
            label="Title"
            name="portal_program_page_title"
            type="text"
            v-model="portalContentAndDesignStore.landingPageResources.general.introduction"
        >
        </text-field>

        <text-editor
            name="portal_program_page_description"
            :text="portalContentAndDesignStore.landingPageResources.general.description"
            @input="(newValue) => { portalContentAndDesignStore.landingPageResources.general.description = newValue }"
        >
        </text-editor>

        <radio-group-inline
            label="Branding"
            name="program_branding_type"
            v-model="portalContentAndDesignStore.landingPageResources.general.program_branding_type"
            :options="[
                        { value: 'none', label: 'None'},
                        { value: 'symbol', label: 'Symbol'},
                        { value: 'logo', label: 'Logo'}
                    ]">
            <template #description>
                Select which image to display above the program title.
            </template>
        </radio-group-inline>

        <toggle
            title="Include links for sign-up and log-in"
            name="display_signup_and_login_links"
            :model-value="!!portalContentAndDesignStore.landingPageResources.general.display_signup_and_login_links"
            @update:model-value="portalContentAndDesignStore.landingPageResources.general.display_signup_and_login_links = $event"
        >
            <template #description>
                Display links for sign-up and log-in under the program description.
            </template>
        </toggle>

        <toggle
            v-if="leadsEnabled"
            title="Include a lead submission link"
            name="display_submit_lead_link"
            :model-value="!!portalContentAndDesignStore.landingPageResources.general.display_submit_lead_link"
            @update:model-value="portalContentAndDesignStore.landingPageResources.general.display_submit_lead_link = $event"
        >
            <template #description>
                Display a link for lead submission.
            </template>
        </toggle>

        <toggle
            v-if="isAffiliateProgram"
            title="Include footer"
            name="show_footer"
            :model-value="!!portalContentAndDesignStore.landingPageResources.general.show_footer"
            @update:model-value="portalContentAndDesignStore.landingPageResources.general.show_footer = $event"
        >
            <template #description>
                The footer is designed with your brand's signature color and features links for sign-up and log-in.
            </template>
        </toggle>

        <toggle
            v-if="isAffiliateProgram"
            title="Show commission"
            name="display_commission"
            :model-value="!!portalContentAndDesignStore.landingPageResources.general.display_commission"
            @update:model-value="portalContentAndDesignStore.landingPageResources.general.display_commission = $event"
        >
            <template #description>
                Include the program commission structure under the program description.
            </template>
        </toggle>

        <text-field
            v-if="isAffiliateProgram && portalContentAndDesignStore.landingPageResources.general.display_commission"
            label="Commission structure"
            name="commission_text"
            type="text"
            placeholder="E.g. 30% for a lifetime"
            v-model="portalContentAndDesignStore.landingPageResources.general.commission_text"
        >
            <template #note>
                Enter your commission structure or leave blank for automatic generation.
            </template>
        </text-field>

    </div>
</template>
